import { useSecurityStore } from '@/stores/security'
import Axios, { type AxiosResponse }from 'axios'

const baseService = {
	baseURL() {
		return `${import.meta.env.VITE_APP_DATASTORMS_URL}`
	},
	formURL(url: string) {
		return this.baseURL() + url
	},
	generateConfigData() {
		const store = useSecurityStore()
		return {
			baseURL: this.baseURL(),
			timeout: 100000,
			headers: {
				'content-type': 'application/json',
				Authorization: `Bearer ${store.accessToken}`
			}
		}
	},

	async refreshAccessToken() {
		const result = await Axios.post(
			'/clients/token',
			{
				grant_type: 'client_credentials',
				client_id: import.meta.env.VITE_APP_DATASTORMS_APIKEY,
				client_secret: import.meta.env.VITE_APP_DATASTORMS_APISECRET
			},
			{
				baseURL: import.meta.env.VITE_APP_DATASTORMS_URL,
				timeout: 100000,
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			}
		)
		const store = useSecurityStore()
		//const today = new Date()
		const accessToken = result.data.access_token
		//accessTokenExpires = today.setMinutes(today.getMinutes() + 30)
		store.accessToken = accessToken

		return accessToken
	},

	async processRequest<T, Z>(endpoint: string, data: unknown) : Promise<Awaited<AxiosResponse<Z>> | undefined> {
		try {
			const store = useSecurityStore()
			if (!store.accessToken) {
			 	await baseService.refreshAccessToken()
			}
			return await Axios.post<T, AxiosResponse<Z>>(
				baseService.formURL(endpoint),
				data,
				baseService.generateConfigData()
			).catch(async function (error) {
				if (error.response) {
					if (error.response.status === 401) {
						await baseService.refreshAccessToken()
						return await Axios.post(
							baseService.formURL(endpoint),
							data,
							baseService.generateConfigData()
						)
					}
				}
			})
		} catch (error) {
		}
	}
}

export default baseService
